import React, { useState, useEffect } from 'react';
import { useBrandLogo } from '../services/brandLogos';

const SIZES = { xs: 'h-4 max-w-[64px]', sm: 'h-6 max-w-[96px]', md: 'h-8 max-w-[128px]' };

const BrandLogo = ({ brand, size = 'sm', showName = true, className = '', testId = 'brand-logo' }) => {
  const logo = useBrandLogo(brand);
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [logo]);

  if (!logo || broken) {
    return showName ? <span data-testid={`${testId}-name`} className={className}>{brand}</span> : null;
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid={testId}>
      <img src={logo} alt={brand} title={brand} onError={() => setBroken(true)} className={`${SIZES[size]} w-auto object-contain no-placeholder`} data-testid={`${testId}-image`} />
      {showName && <span data-testid={`${testId}-name`}>{brand}</span>}
    </span>
  );
};

export default BrandLogo;
